//Auth const
export const USER_SIGNIN = 'user_signin';
export const USER_SIGNIN_SUCCESS = 'user_signin_success';
export const USER_SIGNOUT = 'user_signout';
export const USER_SIGNOUT_SUCCESS = 'user_signout_success';
export const USER_PROFILE_FETCH = 'user_profile_fetch';
export const USER_PROFILE_FETCH_SUCCESS = 'user_profile_fetch_success';
export const USER_PROFILE_FETCH_RESET = 'user_profile_fetch_reset';
export const INIT_URL = 'init_url';

// User
export const USER_CREATE = 'user_create';
export const USER_UPDATE = 'user_update';
export const USER_DELETE = 'user_delete';
export const USER_FETCH = 'user_fetch';
export const USER_FETCH_SUCCESS = 'user_fetch_success';
export const USER_FETCH_RESET = 'user_fetch_reset';
export const USERS_FETCH = 'users_fetch';
export const USERS_FETCH_SUCCESS = 'users_fetch_success';
export const USERS_FETCH_RESET = 'users_fetch_reset';

// Dealer
export const DEALER_CREATE = 'dealer_create';
export const DEALER_UPDATE = 'dealer_update';
export const DEALER_DELETE = 'dealer_delete';
export const DEALER_FETCH = 'dealer_fetch';
export const DEALER_FETCH_SUCCESS = 'dealer_fetch_success';
export const DEALER_FETCH_RESET = 'dealer_fetch_reset';
export const DEALERS_FETCH = 'dealers_fetch';
export const DEALERS_FETCH_SUCCESS = 'dealers_fetch_success';
export const DEALERS_FETCH_RESET = 'dealers_fetch_reset';
export const DEALERS_EXPORT_EXCEL = 'dealers_export_excel';

// Ticket
export const TICKET_CREATE = 'ticket_create';
export const TICKET_UPDATE = 'ticket_update';
export const TICKET_DELETE = 'ticket_delete';
export const TICKET_FETCH = 'ticket_fetch';
export const TICKET_FETCH_SUCCESS = 'ticket_fetch_success';
export const TICKET_FETCH_RESET = 'ticket_fetch_reset';
export const TICKETS_FETCH = 'tickets_fetch';
export const TICKETS_FETCH_SUCCESS = 'tickets_fetch_success';
export const TICKETS_FETCH_RESET = 'tickets_fetch_reset';
export const TICKET_STATUS_FETCH = 'ticket_status_fetch';
export const TICKET_STATUS_FETCH_SUCCESS = 'ticket_status_fetch_success';
export const TICKET_STATUS_FETCH_RESET = 'ticket_status_fetch_reset';
export const TICKETS_EXPORT_EXCEL = 'tickets_export_excel';

// Notification
export const HIDE_MESSAGE = 'hide_message';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const SHOW_INFO_MESSAGE = 'show_info_message';
export const SHOW_SUCCESS_MESSAGE = 'show_success_message';
export const SHOW_WARNING_MESSAGE = 'show_warning_message';
export const SHOW_ERROR_MESSAGE = 'show_error_message';

export const NOTIFICATION_CREATE = 'notification_create';
export const NOTIFICATION_UPDATE = 'notification_update';
export const NOTIFICATION_DELETE = 'notification_delete';
export const NOTIFICATION_FETCH = 'notification_fetch';
export const NOTIFICATION_FETCH_SUCCESS = 'notification_fetch_success';
export const NOTIFICATION_FETCH_RESET = 'notification_fetch_reset';
export const NOTIFICATIONS_FETCH = 'notifications_fetch';
export const NOTIFICATIONS_FETCH_SUCCESS = 'notifications_fetch_success';
export const NOTIFICATIONS_FETCH_RESET = 'notifications_fetch_reset';

// FILTER
export const SHOW_FILTER = 'show_filter';
export const HIDE_FILTER = 'hide_filter';
export const TOGGLE_FILTER = 'toggle_filter';

// Report
export const REPORT_FWPROGRESS_FETCH = 'report_fwprogress_fetch';
export const REPORT_FWPROGRESS_FETCH_RESET = 'report_fwprogress_fetch_reset';
export const REPORT_FWPROGRESS_FETCH_SUCCESS = 'report_fwprogress_fetch_success';
export const REPORT_QCDATA_FETCH = 'report_qcdata_fetch';
export const REPORT_QCDATA_FETCH_RESET = 'report_qcdata_fetch_reset';
export const REPORT_QCDATA_FETCH_SUCCESS = 'report_qcdata_fetch_success';
export const REPORT_SUMMARY_OVERVIEW_FETCH = 'report_summary_overview_fetch';
export const REPORT_SUMMARY_OVERVIEW_FETCH_RESET = 'report_summary_overview_fetch_reset';
export const REPORT_SUMMARY_OVERVIEW_FETCH_SUCCESS = 'report_summary_overview_fetch_success';
export const REPORT_SUMMARY_FACTOR_FETCH = 'report_summary_factor_fetch';
export const REPORT_SUMMARY_FACTOR_FETCH_RESET = 'report_summary_factor_fetch_reset';
export const REPORT_SUMMARY_FACTOR_FETCH_SUCCESS = 'report_summary_factor_fetch_success';
export const REPORT_SUMMARY_CARMODEL_FETCH = 'report_summary_carmodel_fetch';
export const REPORT_SUMMARY_CARMODEL_FETCH_RESET = 'report_summary_carmodel_fetch_reset';
export const REPORT_SUMMARY_CARMODEL_FETCH_SUCCESS = 'report_summary_carmodel_fetch_success';
export const REPORT_LATEST_FETCH = 'report_latest_fetch';
export const REPORT_LATEST_FETCH_RESET = '  report_latest_fetch_reset';
export const REPORT_LATEST_FETCH_SUCCESS = '  report_latest_fetch_success';
export const REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH = 'report_summary_overview_default_fetch';
export const REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_RESET = '  report_summary_overview_default_fetch_reset';
export const REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_SUCCESS = '  report_summary_overview_default_fetch_success';
export const REPORT_CUSTOMER_VOICE_FETCH = 'report_customer_voice_fetch';
export const REPORT_CUSTOMER_VOICE_FETCH_RESET = 'report_customer_voice_fetch_reset';
export const REPORT_CUSTOMER_VOICE_FETCH_SUCCESS = 'report_customer_voice_fetch_success';
export const REPORT_RANKING_FETCH = 'report_ranking_fetch';
export const REPORT_RANKING_FETCH_RESET = 'report_ranking_fetch_reset';
export const REPORT_RANKING_FETCH_SUCCESS = 'report_ranking_fetch_success';
